import styled from '@emotion/styled';

export const UserList = styled('ul', { label: 'UserList' })`
    list-style-type: none;
    margin: 0;
    overflow-y: auto;
    padding: 0;
`;
